import React from "react";
import HeaderBar from "../../../common/HeaderBar";
import SideBar from "../../../common/SideBar";
import ReportBody from "./reportBody";

const ReportMainPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div
        className="overflow-hidden inner-page-content inner-page-content--dashboard"
      >
        <SideBar />
        <ReportBody />
      </div>
    </main>
  );
};

export default ReportMainPage;
